import request from '../../plugins/request'

//登录用户信息
export function getAuthorUserInfo(data) {
  return request({
    url: '/api/AuthorUser/GetAuthorUserInfo',
    method: 'post',
    data,
    baseURL: `${process.env.VUE_APP_BASE_API}`
  })
}
//登录获取token
export function authorUserLogin(data) {
  return request({
    url: '/api/Authentications/AuthorUserLogin',
    method: 'post',
    data,
    baseURL: `${process.env.VUE_APP_LOGIN_API}`
  })
}

//鉴权中心登录验证username password
export function login(data) {
  return request({
    url: '/api/Authentications/Login',
    method: 'post',
    data,
    baseURL: `${process.env.VUE_APP_LOGIN_API}`
  })
}